import { useQuery } from "react-query"
import { request } from "../util/request"

export function useBandActivityEvents(bandId: number, page = 1, perPage = 20) {
  return useQuery(
    ["band_activity_events", bandId, page, perPage],
    getBandActivityEvents,
    { keepPreviousData: true },
  )
}

const getBandActivityEvents = async ({ queryKey }: { queryKey: any[] }) => {
  const [key, bandId, page, perPage] = queryKey
  return await request({
    queryKey: [
      key,
      {
        path: `/api/v1/activity_events.json`,
        params: { band_id: bandId, per_page: perPage, page },
      },
    ],
  })
}
